var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhpLoadingEquialize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BEta",
    imageRendering: "auto",
    baseProfile: "basic",
    x: "0px",
    y: "0px",
    width: 211,
    height: 198,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scene-1",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol-1",
    transform: "translate(109.3 94.05)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer961_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 41.15L-9.3 -44.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer950_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 -44.5L-9.3 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer949_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 57.75L-9.3 -60.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer948_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 74.35L-9.3 -75.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer947_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 90.95L-9.3 -91.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer946_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 107.55L-9.3 -106.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer945_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 -122.4L-9.3 124.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer944_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 96.5L-9.3 -96.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_41.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer943_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 68.8L-9.3 -70.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer942_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-9.3 -44.5L-9.3 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer940_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 28.7L-5.6 -32.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer939_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 32.85L-5.6 -36.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer938_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 37L-5.6 -40.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer937_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 -44.5L-5.6 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer936_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 48.8L-5.6 -49.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer935_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 56.45L-5.6 -54.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer934_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 64.1L-5.6 -60.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer933_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 71.75L-5.6 -65.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer927_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 -27.9L-5.6 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer926_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 35.5L-5.6 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer925_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 46.5L-5.6 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer924_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 57.45L-5.6 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer923_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 68.45L-5.6 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer922_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 -70.65L-5.6 79.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer921_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 61.1L-5.6 -56.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_40.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer920_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 42.85L-5.6 -42.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_40.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer919_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-5.6 -27.9L-5.6 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer915_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 9.6L-13.05 -12.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer904_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 -12.55L-13.05 9.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer903_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 20.85L-13.05 -21.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer902_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 32.05L-13.05 -30.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer901_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 43.3L-13.05 -39.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer900_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 54.5L-13.05 -49"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer899_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 -58.1L-13.05 65.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer898_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 47L-13.05 -42.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_39.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer897_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 28.3L-13.05 -27.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_39.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer896_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-13.05 -12.55L-13.05 9.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer892_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 21.7L-1.85 -21.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer881_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 -21.75L-1.85 21.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer880_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 37.25L-1.85 -35.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer879_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 52.85L-1.85 -48.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer878_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 68.4L-1.85 -62.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer877_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 84L-1.85 -75.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer876_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 -89.35L-1.85 99.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer875_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 73.6L-1.85 -66.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_38.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer874_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 47.65L-1.85 -44.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_38.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer873_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-1.85 -21.75L-1.85 21.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer869_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 32.25L1.85 -30.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer858_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 -30.95L1.85 32.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer857_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 43.9L1.85 -41.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer856_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 55.5L1.85 -51.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer855_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 67.15L1.85 -61.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer854_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 78.75L1.85 -72.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer853_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 -82.4L1.85 90.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer852_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 71L1.85 -65.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_37.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer851_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 51.65L1.85 -48.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_37.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer850_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M1.85 -30.95L1.85 32.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer848_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 28.7L5.9 -32.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer847_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 32.85L5.9 -36.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer846_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 37L5.9 -40.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer845_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 -44.5L5.9 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer844_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 48.8L5.9 -49.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer843_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 56.45L5.9 -54.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer842_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 64.1L5.9 -60.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer841_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 71.75L5.9 -65.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer835_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 -27.9L5.9 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer834_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 35.5L5.9 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer833_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 46.5L5.9 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer832_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 57.45L5.9 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer831_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 68.45L5.9 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer830_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 -70.65L5.9 79.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer829_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 61.1L5.9 -56.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_36.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer828_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 42.85L5.9 -42.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_36.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer827_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M5.9 -27.9L5.9 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer825_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 43.25L9.8 -46.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer824_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 45.4L9.8 -48.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer823_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 47.5L9.8 -50.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer822_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 -52.55L9.8 49.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer821_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 66.4L9.8 -68.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer820_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 83.2L9.8 -84.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer819_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 100.05L9.8 -100.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer818_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 116.85L9.8 -116.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer817_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 -132.7L9.8 133.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer816_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 115.15L9.8 -115.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer815_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 96.65L9.8 -97.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer814_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 78.15L9.8 -79.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer813_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 59.65L9.8 -62.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer812_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 -44.5L9.8 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer811_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 54.5L9.8 -55.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer810_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 67.9L9.8 -67.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer809_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 81.3L9.8 -78.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer808_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 94.6L9.8 -90.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer807_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 -101.45L9.8 108"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer806_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 85.7L9.8 -82.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_35.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer805_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 63.45L9.8 -63.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_35.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer804_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M9.8 -44.5L9.8 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer800_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 9.2L13.3 -12.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer789_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 -12.95L13.3 9.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer788_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 18.9L13.3 -20.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer787_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 28.6L13.3 -28.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer786_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 38.25L13.3 -36.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer785_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 47.9L13.3 -44.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer784_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 -52.6L13.3 57.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer783_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 41.5L13.3 -39.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_34.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer782_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 25.35L13.3 -26.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_34.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer781_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.3 -12.95L13.3 9.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer777_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 14.05L17 -17.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer775_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 20.2L17 -22.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer771_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 44.8L17 -43.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer769_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 41.75L17 -40.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer768_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 32.5L17 -32.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer767_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 23.3L17 -25.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer766_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 -17.55L17 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer765_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 21.45L17 -23.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer764_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 28.8L17 -29.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer763_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 36.2L17 -36.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer762_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 43.55L17 -42.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer761_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 -48.3L17 51"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.522;.565;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer760_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 38.65L17 -38.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.609;.652;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_33.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer759_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 26.35L17 -27.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.696;.739;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_33.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer758_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M17 -17.55L17 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer756_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 28.7L-16.55 -32.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer755_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 32.85L-16.55 -36.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer754_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 37L-16.55 -40.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer753_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 -44.5L-16.55 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer752_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 48.8L-16.55 -49.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer751_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 56.45L-16.55 -54.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer750_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 64.1L-16.55 -60.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer749_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 71.75L-16.55 -65.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer743_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 -27.9L-16.55 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer742_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 35.5L-16.55 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer741_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 46.5L-16.55 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer740_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 57.45L-16.55 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer739_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 68.45L-16.55 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer738_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 -70.7L-16.55 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer737_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 61.1L-16.55 -56.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_32.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer736_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 42.85L-16.55 -42.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_32.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer735_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.55 -27.9L-16.55 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer731_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 4.55L-20.2 -9.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer720_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 -9.5L-20.2 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer719_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 10.1L-20.2 -14.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer718_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 15.7L-20.2 -20.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer717_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 21.25L-20.2 -25.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer716_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 26.85L-20.2 -30.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer715_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 -35.9L-20.2 32.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer714_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 23.1L-20.2 -27.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_31.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer713_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 13.85L-20.2 -18.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer712_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-20.2 -9.5L-20.2 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer708_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 4.55L-23.7 -9.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer697_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 -9.5L-23.7 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer696_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 22.55L-23.7 -26.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.391;.435;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer695_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 40.55L-23.7 -43.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.435;.478;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer694_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 58.6L-23.7 -60.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.478;.522;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer693_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 76.6L-23.7 -77.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.522;.565;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer692_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 -94.9L-23.7 94.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer691_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 64.6L-23.7 -66.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_30.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer690_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 34.55L-23.7 -37.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_30.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer689_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-23.7 -9.5L-23.7 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer686_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 41.15L34.9 -44.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer684_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 61.9L34.9 -63.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer683_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 82.65L34.9 -83.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer682_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 103.4L34.9 -102.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer676_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 -44.5L34.9 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.826;.87;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer671_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 -122.4L34.9 124.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer670_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 107.55L34.9 -106.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer669_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 90.95L34.9 -91.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer668_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 74.35L34.9 -75.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_29.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer667_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 57.75L34.9 -60.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_29.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer666_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.9 -44.5L34.9 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer663_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 79.35L38.65 -70.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer661_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 65.7L38.65 -59.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer660_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 52.05L38.65 -49.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer659_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 38.25L38.65 -38.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer653_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 -70.7L38.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.826;.87;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer648_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 -27.9L38.65 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer647_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 35.5L38.65 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer646_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 46.5L38.65 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer645_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 57.45L38.65 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_28.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer644_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 68.45L38.65 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_28.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer643_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M38.65 -70.7L38.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer642_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 -89.35L42.4 99.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer641_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M39.55 77.05L39.55 -70.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer640_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M36.8 54.6L36.8 -50.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer639_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M33.9 32.1L33.9 -31.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer632_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 -58.1L31.15 65.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer626_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 -12.55L31.15 9.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.783;.826;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer625_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 18.95L31.15 -20.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.304;.348;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer624_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 28.3L31.15 -27.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.348;.391;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer623_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 37.7L31.15 -35.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.391;.435;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer622_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 47L31.15 -42.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.435;.478;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_27.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer621_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 56.4L31.15 -50.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.478;.522;.565;.609;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_27.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer620_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M31.15 -58.1L31.15 65.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer619_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 -30.9L46.05 32.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer618_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M44.25 27L44.25 -26.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer606_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 37.25L42.4 -35.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer605_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 52.85L42.4 -48.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer604_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 68.35L42.4 -62.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer603_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 84L42.4 -75.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer602_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 -89.35L42.4 99.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer601_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 -21.75L42.4 21.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.435;.478;.87;.913;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer600_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 41.15L42.4 -38.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer599_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 60.6L42.4 -55.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_26.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer598_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 80.1L42.4 -72.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_26.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer597_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M42.4 -89.35L42.4 99.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer596_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 -70.7L50.05 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer595_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M48.75 63.7L48.75 -57.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer594_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M47.45 47.95L47.45 -44.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer583_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 -30.9L46.05 32.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;.826;.87;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer582_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 46.8L46.05 -43.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer581_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 61.35L46.05 -56.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer580_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 75.85L46.05 -69.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer579_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 -82.4L46.05 90.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.609;.652;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer578_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 78.75L46.05 -72.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.565;.609;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer577_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 67.15L46.05 -61.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.522;.565;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer576_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 55.5L46.05 -51.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.478;.522;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_25.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer575_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 43.95L46.05 -41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.435;.478;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_25.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer574_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M46.05 -30.9L46.05 32.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer573_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -22.1L54.05 18.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer572_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M52.05 49.15L52.05 -46.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer561_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 -70.7L50.05 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer556_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 -27.9L50.05 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer555_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 35.5L50.05 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer554_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 46.5L50.05 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer553_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 57.45L50.05 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_24.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer552_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 68.45L50.05 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_24.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer551_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M50.05 -70.7L50.05 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer550_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -52.6L54.05 57.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer549_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 74.9L54.05 -70.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer548_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 92.2L54.05 -89.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer547_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -107.35L54.05 109.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer546_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 97L54.05 -93.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer545_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 84.45L54.05 -80.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer544_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -66.9L54.05 71.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer543_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 78.85L54.05 -75.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer542_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 85.85L54.05 -83.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer541_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 92.75L54.05 -91.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer540_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 99.65L54.05 -99.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer539_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -107.75L54.05 106.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer538_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 93.45L54.05 -95.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer537_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 80.4L54.05 -82.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer536_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 67.3L54.05 -69.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer535_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 54.25L54.05 -57.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer534_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -44.5L54.05 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer533_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 66.1L54.05 -66.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer532_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 91.1L54.05 -87.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer531_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -109.15L54.05 116.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer530_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 83.55L54.05 -80.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_23.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer529_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 51.2L54.05 -51.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_23.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer528_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -22.1L54.05 18.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer527_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 -17.55L61.15 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer526_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M59.95 28.6L59.95 -29.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer525_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M58.7 43.15L58.7 -40.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer523_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 49.55L57.5 -45.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer522_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 41.5L57.5 -39.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer520_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 25.35L57.5 -26.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer519_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 17.3L57.5 -19.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer517_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 21.3L57.5 -22.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer516_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 33.45L57.5 -32.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;.696;.739;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer515_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 45.55L57.5 -42.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer514_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 -52.6L57.5 57.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;.826;.87;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer513_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 47.9L57.5 -44.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer512_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 38.25L57.5 -36.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer511_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 28.6L57.5 -28.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer510_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 18.9L57.5 -20.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer509_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M57.5 -12.95L57.5 9.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer508_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M56.65 21.3L56.65 -22.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer507_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M55.75 33.45L55.75 -32.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_22.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer506_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.95 45.55L54.95 -42.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_22.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer505_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.05 -52.6L54.05 57.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer504_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 -70.7L27.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer503_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M44.45 65.2L44.45 -59.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer493_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 44.8L61.15 -43.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer492_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 38.65L61.15 -38.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer490_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 26.35L61.15 -27.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer489_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 20.2L61.15 -22.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer488_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 -17.55L61.15 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.696;.739;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer487_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 23.3L61.15 -25.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer485_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 41.75L61.15 -40.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer484_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 -48.3L61.15 51"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.522;.565;.87;.913;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_21.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer483_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 32.5L61.15 -32.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.174;.217;.391;.435;.609;.652;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer482_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M61.15 -17.55L61.15 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer481_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 -9.5L24 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer480_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M25.9 42L25.9 -40.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer469_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 -70.7L27.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer464_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 -27.9L27.65 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer463_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 35.5L27.65 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer462_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 46.5L27.65 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer461_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 57.45L27.65 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_20.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer460_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 68.45L27.65 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_20.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer459_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M27.65 -70.7L27.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer458_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 -9.5L20.5 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer457_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M21.4 4.55L21.4 -9.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer456_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M22.25 4.55L22.25 -9.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer455_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M23.15 4.55L23.15 -9.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer453_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 10.1L24 -14.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer452_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 15.7L24 -20.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer451_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 21.25L24 -25.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer450_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 26.85L24 -30.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer448_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 28.4L24 -32.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer447_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 24.45L24 -28.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer446_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 20.45L24 -24.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer445_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 16.5L24 -20.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer444_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 12.5L24 -17.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer443_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 8.55L24 -13.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer442_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 -9.5L24 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.783;.826;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer441_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 11.5L24 -16.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer439_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 25.45L24 -29.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer438_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 -35.9L24 32.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_19.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer437_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 18.5L24 -22.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.174;.217;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_19.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer436_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M24 -9.5L24 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer435_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 -44.5L-54.35 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer434_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-16.85 22.85L-16.85 -27"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer432_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 22.55L20.5 -26.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer431_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 40.55L20.5 -43.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer430_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 58.6L20.5 -60.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer429_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 76.6L20.5 -77.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer427_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 81.75L20.5 -82.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer426_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 68.85L20.5 -70.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer425_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 56L20.5 -58.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer424_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 43.15L20.5 -46.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer423_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 30.3L20.5 -33.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer422_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 17.4L20.5 -21.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer421_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 -9.5L20.5 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer417_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 -94.9L20.5 94.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer416_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 72.1L20.5 -73.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.217;.261;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer415_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 49.6L20.5 -52.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.261;.304;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_18.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer414_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 27.05L20.5 -30.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.304;.348;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_18.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer413_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M20.5 -9.5L20.5 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer412_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 -70.7L-50.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer411_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-52.5 60.35L-52.5 -57.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer400_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 -44.5L-54.35 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer395_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 -122.4L-54.35 124.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer394_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 107.55L-54.35 -106.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer393_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 90.95L-54.35 -91.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer392_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 74.35L-54.35 -75.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_17.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer391_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 57.75L-54.35 -60.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_17.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer390_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.35 -44.5L-54.35 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer389_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 -58.15L-58.15 65.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer388_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-54.4 72.55L-54.4 -64.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer377_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 -70.7L-50.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer372_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 -27.9L-50.65 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer371_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 35.5L-50.65 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer370_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 46.5L-50.65 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer369_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 57.45L-50.65 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_16.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer368_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 68.45L-50.65 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_16.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer367_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-50.65 -70.7L-50.65 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer366_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 -89.4L-46.9 99.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer365_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-49.7 77.1L-49.7 -70.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer364_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-52.5 54.6L-52.5 -50.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer363_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-55.35 32.1L-55.35 -31.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer356_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 -58.15L-58.15 65.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer350_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 -12.55L-58.15 9.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.783;.826;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer349_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 18.95L-58.15 -20.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.304;.348;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer348_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 28.3L-58.15 -27.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.348;.391;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer347_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 37.7L-58.15 -35.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.391;.435;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer346_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 47.05L-58.15 -42.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.435;.478;.609;.652;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_15.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer345_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 56.45L-58.15 -50.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.478;.522;.565;.609;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_15.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer344_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-58.15 -58.15L-58.15 65.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer343_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 -30.9L-43.2 32.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer342_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-45.05 27L-45.05 -26.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer330_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 37.25L-46.9 -35.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer329_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 52.85L-46.9 -48.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer328_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 68.4L-46.9 -62.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer327_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 83.95L-46.9 -75.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer326_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 -89.4L-46.9 99.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer325_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 -21.75L-46.9 21.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.435;.478;.87;.913;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer324_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 41.15L-46.9 -38.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer323_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 60.65L-46.9 -55.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_14.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer322_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 80.05L-46.9 -72.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_14.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer321_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-46.9 -89.4L-46.9 99.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer320_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 -70.7L-39.2 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer319_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-40.55 63.7L-40.55 -57.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer318_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-41.85 48L-41.85 -44.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer307_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 -30.9L-43.2 32.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;.826;.87;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer306_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 46.8L-43.2 -43.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer305_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 61.35L-43.2 -56.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer304_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 75.85L-43.2 -69.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer303_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 -82.4L-43.2 90.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.609;.652;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer302_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 78.75L-43.2 -72.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.565;.609;.652;.696;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer301_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 67.15L-43.2 -61.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.522;.565;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer300_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 55.5L-43.2 -51.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.478;.522;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_13.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer299_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 43.9L-43.2 -41.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.435;.478;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_13.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer298_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-43.2 -30.9L-43.2 32.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer297_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -22.1L-35.25 18.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer296_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-37.2 49.1L-37.2 -46.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer285_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 -70.7L-39.2 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer280_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 -27.9L-39.2 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer279_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 35.5L-39.2 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer278_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 46.5L-39.2 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer277_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 57.45L-39.2 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_12.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer276_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 68.45L-39.2 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_12.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer275_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-39.2 -70.7L-39.2 79.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer274_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -52.55L-35.25 57.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer273_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 74.95L-35.25 -70.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer272_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 92.2L-35.25 -89.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer271_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -107.35L-35.25 109.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer270_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 97L-35.25 -93.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer269_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 84.5L-35.25 -80.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer268_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -66.85L-35.25 72"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer267_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 78.9L-35.25 -75.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer266_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 85.8L-35.25 -83.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer265_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 92.75L-35.25 -91.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer264_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 99.65L-35.25 -99.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer263_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -107.75L-35.25 106.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer262_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 93.45L-35.25 -95.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer261_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 80.4L-35.25 -82.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer260_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 67.3L-35.25 -69.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer259_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 54.25L-35.25 -57.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer258_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -44.5L-35.25 41.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer257_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 59.9L-35.25 -60.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer256_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 78.6L-35.25 -76.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer255_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 97.35L-35.25 -93"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer254_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -109.15L-35.25 116.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_11.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer253_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 67.4L-35.25 -65.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer252_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -22.1L-35.25 18.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer251_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 -17.55L-28.1 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.957;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer250_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-29.3 28.6L-29.3 -29.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer249_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-30.55 43.1L-30.55 -40.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer247_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 49.55L-31.75 -45.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer246_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 41.5L-31.75 -39.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer244_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 25.35L-31.75 -26.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer243_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 17.3L-31.75 -19.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer241_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 21.3L-31.75 -22.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer240_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 33.45L-31.75 -32.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;.696;.739;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer239_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 45.55L-31.75 -42.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer238_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 -52.55L-31.75 57.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;.826;.87;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer237_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 47.95L-31.75 -44.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer236_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 38.25L-31.75 -36.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer235_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 28.6L-31.75 -28.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer234_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 18.9L-31.75 -20.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer233_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-31.75 -12.95L-31.75 9.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer232_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-32.6 21.3L-32.6 -22.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer231_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-33.5 33.45L-33.5 -32.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_10.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer230_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-34.35 45.55L-34.35 -42.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_10.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer229_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-35.25 -52.55L-35.25 57.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer217_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 44.8L-28.1 -43.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer216_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 38.65L-28.1 -38.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer214_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 26.35L-28.1 -27.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer213_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 20.2L-28.1 -22.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer212_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 -17.55L-28.1 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.696;.739;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer211_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 23.3L-28.1 -25.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer209_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 41.75L-28.1 -40.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.565;.609;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer208_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 -48.35L-28.1 50.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.522;.565;.87;.913;1",
    values: "none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_9.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer207_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 32.5L-28.1 -32.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.174;.217;.391;.435;.609;.652;.783;.826;.913;.957;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_9.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer206_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-28.1 -17.55L-28.1 14.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_8.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer204_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 79.4L-61.6 -70.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_8.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer193_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 -70.65L-61.6 79.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;.87;.913;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_8.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer188_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 -27.9L-61.6 24.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_8.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer187_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 35.5L-61.6 -36.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;.261;.304;.609;.652;.696;.739;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_8.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer186_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 46.5L-61.6 -45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.304;.348;.565;.609;.739;.783;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_8.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer185_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 57.45L-61.6 -53.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.348;.391;.522;.565;.783;.826;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_8.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer184_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 68.45L-61.6 -62.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.391;.435;.478;.522;.826;.87;1",
    values: "none;inline;none;inline;none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_8.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer183_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-61.6 -70.65L-61.6 79.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer179_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 4.55L-65.25 -9.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer177_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 10.1L-65.25 -14.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer176_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 15.7L-65.25 -20.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer175_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 21.25L-65.25 -25.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer174_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 26.85L-65.25 -30.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer172_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 28.4L-65.25 -32.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer171_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 24.45L-65.25 -28.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer170_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 20.45L-65.25 -24.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer169_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 16.5L-65.25 -20.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer168_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 12.5L-65.25 -17.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer167_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 8.55L-65.25 -13.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer166_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 -9.5L-65.25 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;.783;.826;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer165_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 11.5L-65.25 -16.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer163_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 25.45L-65.25 -29.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer162_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 -35.9L-65.25 32.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;.565;.609;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_7.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer161_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 18.5L-65.25 -22.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;.174;.217;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_7.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer160_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-65.25 -9.5L-65.25 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer158_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 34.55L-68.75 -37.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer157_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 64.6L-68.75 -66.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer155_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 81.75L-68.75 -82.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer154_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 68.85L-68.75 -70.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer153_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 56L-68.75 -58.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer152_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 43.15L-68.75 -46.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer151_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 30.3L-68.75 -33.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer150_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 17.4L-68.75 -21.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer148_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 27.05L-68.75 -30.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer147_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 49.6L-68.75 -52.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer146_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 72.1L-68.75 -73.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer145_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 -94.9L-68.75 94.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.826;.87;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer144_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 76.65L-68.75 -77.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer143_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 58.55L-68.75 -60.8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer142_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 40.55L-68.75 -43.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer141_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 22.6L-68.75 -26.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer140_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 -9.5L-68.75 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.522;.565;.957;1",
    values: "none;inline;none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_6.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer138_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 4.55L-68.75 -9.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_6.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer137_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-68.75 -9.5L-68.75 4.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer133_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 3.5L-72.35 -1.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer132_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 -1.9L-72.35 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer131_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 4.3L-72.35 -3.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer130_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 5.15L-72.35 -4.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer129_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 6L-72.35 -5.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer128_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 6.8L-72.35 -6.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer127_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 -8.15L-72.35 7.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer126_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 6.5L-72.35 -7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer125_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 5.35L-72.35 -5.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer124_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 4.25L-72.35 -4.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer123_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 3.1L-72.35 -3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer122_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 -2.35L-72.35 1.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer121_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 2.55L-72.35 -2.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer120_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 3.2L-72.35 -3.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer119_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 3.8L-72.35 -4.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer118_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 4.45L-72.35 -4.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer117_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 -5.3L-72.35 5.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer116_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 4.55L-72.35 -4.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_5.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer115_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 4.05L-72.35 -3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_5.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer114_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-72.35 -1.9L-72.35 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer110_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 3.5L65.05 -1.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer109_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 -1.9L65.05 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer108_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 4.3L65.05 -3.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer107_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 5.15L65.05 -4.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer106_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 6L65.05 -5.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer105_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 6.8L65.05 -6.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer104_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 -8.15L65.05 7.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer103_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 6.5L65.05 -7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer102_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 5.35L65.05 -5.85"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer101_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 4.25L65.05 -4.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer100_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 3.1L65.05 -3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer99_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 -2.35L65.05 1.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer98_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 2.55L65.05 -2.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer97_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 3.2L65.05 -3.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer96_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 3.8L65.05 -4.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer95_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 4.45L65.05 -4.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer94_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 -5.3L65.05 5.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer93_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 4.55L65.05 -4.15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_4.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer92_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 4.05L65.05 -3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_4.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer91_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M65.05 -1.9L65.05 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer89_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 5.6L-75.8 -5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer87_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 6.8L-75.8 -6.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer86_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 6L-75.8 -5.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer85_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 5.15L-75.8 -4.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer84_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 4.3L-75.8 -3.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer83_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 -1.9L-75.8 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer82_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 3.9L-75.8 -2.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer81_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 4.3L-75.8 -3.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer80_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 4.65L-75.8 -4.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer79_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 -5.3L-75.8 5.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer78_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 4.45L-75.8 -4.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer77_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 3.8L-75.8 -4.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer76_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 3.2L-75.8 -3.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer75_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 2.55L-75.8 -2.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer74_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 -2.35L-75.8 1.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer73_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 3.85L-75.8 -4.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer72_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 5.75L-75.8 -6.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer71_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 -8.15L-75.8 7.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer70_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 6.25L-75.8 -6.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_3.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer69_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 4.95L-75.8 -3.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_3.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer68_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-75.8 -1.9L-75.8 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer66_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 5.6L67.9 -5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.913;.957;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer64_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 6.8L67.9 -6.9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer63_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 6L67.9 -5.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer62_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 5.15L67.9 -4.4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer61_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 4.3L67.9 -3.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer60_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 -1.9L67.9 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.652;.696;.957;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer59_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 3.9L67.9 -2.75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer58_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 4.3L67.9 -3.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer57_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 4.65L67.9 -4.45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer56_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 -5.3L67.9 5.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer55_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 4.45L67.9 -4.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer54_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 3.8L67.9 -4.1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.391;.435;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer53_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 3.2L67.9 -3.55"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer52_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 2.55L67.9 -2.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer51_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 -2.35L67.9 1.95"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer50_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 3.85L67.9 -4.3"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer49_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 5.75L67.9 -6.2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer48_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 -8.15L67.9 7.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.87;.913;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer47_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 6.25L67.9 -6.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_2.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer46_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 4.9L67.9 -4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_2.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer45_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M67.9 -1.9L67.9 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer42_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M91.9 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer41_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M87.9 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer40_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M83.9 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer39_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M79.9 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer38_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M75.9 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer36_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.9 .1L93.65 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer35_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.85 .1L88.75 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer34_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.9 .1L83.95 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer33_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.9 .1L79.1 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer32_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.9 .1L74.25 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer31_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M95.9 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.913;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer30_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M91.1 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer29_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M86.3 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer28_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M81.5 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer27_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M76.7 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer26_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.9 .1L98.5 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer25_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.9 .1L90.4 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_1.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer24_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.85 .1L82.3 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer23_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M71.9 .1L74.25 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer20_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-99.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.87;.913;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer19_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-95.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.826;.87;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer18_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-91.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.783;.826;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer17_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-87.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.739;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer16_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-83.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.696;.739;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer14_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-101.15 .1L-79.4 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.609;.652;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer13_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-96.35 .1L-79.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.565;.609;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer12_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-91.5 .1L-79.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.522;.565;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer11_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-86.65 .1L-79.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.478;.522;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer10_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-79.45 .1L-81.8 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.435;.478;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer9_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-103.45 .1L-106.05 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.348;.391;.913;1",
    values: "none;inline;none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer8_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106 .1L-98.6 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.304;.348;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer7_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-93.85 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.261;.304;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer6_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-89.05 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.217;.261;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer5_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-106.05 .1L-84.25 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.174;.217;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer4_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-79.45 .1L-106.05 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.13;.174;.652;.696;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer3_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-97.95 .1L-79.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.087;.13;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Symbol 1_0.1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer2_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-89.9 .1L-79.45 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;.087;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol 1_0.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer1_0_1_STROKES",
    stroke: "#FFBE10",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M-79.45 .1L-81.8 .1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;.043;1",
    values: "inline;none;none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhpLoadingEquialize);
export default __webpack_public_path__ + "static/media/whp-loading-equialize.4456b4a8644e3a405bbe16653bd76a26.svg";
export { ForwardRef as ReactComponent };